import {computed, ref} from "vue";
import {isEmpty, isStringEmpty} from "@/service/utils";
import {SOURCE_TYPES, TARGET_TYPES} from "@/pages/CreateConnection/constants/connectionTypes";
import {ConnectionRequestBuilder} from "@/pages/CreateConnection/services/connectionRequestBuilder";
import {Api} from "@/service/api";

function hasSelectedItems(items) {
    return Array.isArray(items) && items.length > 0
}

function getBitrixDate(date) {
    if (!date) {
        return null
    }

    if (date.type === 'offset') {
        const result = new Date()
        const multiplier = date.offsetOperation?.type === 'MINUS' ? -1 : 1

        if (date.offsetName?.type === 'MONTH') {
            result.setMonth(result.getMonth() + (date.length * multiplier))
            return result
        }

        if (date.offsetName?.type === 'DAY') {
            result.setDate(result.getDate() + (date.length * multiplier))
            return result
        }
    }

    if (date.type === 'exact') {
        return date.date ? new Date(date.date) : null
    }

    return null
}

function isBitrixDateRangeValid(filter) {
    const start = getBitrixDate(filter.startDate)
    const end = getBitrixDate(filter.endDate)
    return start !== null && end !== null && end >= start
}

function isBitrixFilterValid(bitrixUpload) {
    const dataType = bitrixUpload?.dataType
    const filter = bitrixUpload?.filter || {}

    if (dataType === 'DEALS') {
        return hasSelectedItems(filter.directions)
            && hasSelectedItems(filter.stages)
            && isBitrixDateRangeValid(filter)
    }

    if (dataType === 'LEADS') {
        return hasSelectedItems(filter.stages) && isBitrixDateRangeValid(filter)
    }

    if (dataType === 'CONTACTS') {
        return isBitrixDateRangeValid(filter)
    }

    return false
}

function areBitrixConditionsValid(conditions = []) {
    for (const condition of conditions) {
        if (isEmpty(condition.field)) {
            return false
        }
        if (isEmpty(condition.criteria)) {
            return false
        }
        if (!(
            condition.criteria.criteria_type === "IS_TRUE" ||
            condition.criteria.criteria_type === "IS_FALSE"
        ) && (condition.filter_value?.data === "" || condition.filter_value?.data == null)) {
            return false
        }
    }
    return true
}

export function useConnectionCreate(
    connection,
    yandexUpload,
    selectedYandexAccount,
    vkAdsUpload,
    selectedVkAccount,
    bitrixUpload,
    bitrixAccount,
    sourceType,
    isYandexDataInputRight,
    isVKDataInputRight,
    isBitrixDataInputRight,
    toaster,
    route,
    router
) {
    const isLoadingCreating = ref(false)


    const isCreateButtonActive = computed(() => {
        if (sourceType.value === 'GOOGLE_SHEETS') {
            for (const file of connection.value.files_source) {
                if (isStringEmpty(file.id) || isStringEmpty(file.tab.sheetId)) {
                    return false
                }
            }

            if (connection.value.filter.conditions.length > 0) {
                for (const condition of connection.value.filter.conditions) {
                    if (isEmpty(condition.column)) {
                        return false
                    }
                    if (isEmpty(condition.criteria)) {
                        return false
                    }
                    if (!((isEmpty(condition.criteria) ||
                            condition.criteria.criteria_type === "IS_TRUE" ||
                            condition.criteria.criteria_type === "IS_FALSE")) &&
                        (condition.filter_value?.data === "" )
                    ) return false
                }
            }
        }
        else if (sourceType.value === 'YANDEX_DIRECT_STAT') {
            return isYandexDataInputRight
        }
        else if (sourceType.value === 'VKONTAKTE_CAMPAIGN_STAT') {
            return isVKDataInputRight
        }
        else if (sourceType.value === 'BITRIX_UPLOAD') {
            if (!isBitrixDataInputRight.value) {
                return false
            }
            if (!isBitrixFilterValid(bitrixUpload.value)) {
                return false
            }
            if (!areBitrixConditionsValid(bitrixUpload.value?.filter?.conditions)) {
                return false
            }
        }

        if (isStringEmpty(connection.value.file_target?.id) || isStringEmpty(connection.value.file_target?.tab.sheetId)) {
            return false
        }

        return true
    })

    async function createConnection() {
        isLoadingCreating.value = true
        let sourceUpload = []

        let account = null
        let filterUpload = connection.value.filter

        if (sourceType.value === SOURCE_TYPES.GOOGLE_SHEETS) {
            sourceUpload = connection.value.files_source
        }
        if (sourceType.value === SOURCE_TYPES.YANDEX_DIRECT_STAT) {
            sourceUpload = yandexUpload.value
            account = selectedYandexAccount.value
        }
        if (sourceType.value === SOURCE_TYPES.VKONTAKTE_CAMPAIGN_STAT) {
            sourceUpload = vkAdsUpload.value
            account = selectedVkAccount.value
        }
        if (sourceType.value === SOURCE_TYPES.BITRIX_UPLOAD) {
            sourceUpload = bitrixUpload.value
            account = bitrixAccount.value
            filterUpload = { conditions: [] }
        }
        const targetUpload = {
            spreadsheet_id: connection.value.file_target.id,
            tab_id: connection.value.file_target.tab.sheetId.toString(),
            action_type: "EXIST",
        }

        const connectionRequestBuilder = new ConnectionRequestBuilder(
            sourceUpload,
            targetUpload,
            sourceType.value,
            TARGET_TYPES.GOOGLE_SHEETS,
            filterUpload,
            account,
            null
        )
        const requestBody = connectionRequestBuilder.build()
        console.log('[CreateConnection] request body', {
            workflow_id: route.params.workflow_id,
            sourceType: sourceType.value,
            requestBody,
        })
        const response = await Api.createConnection(route.params.workflow_id, requestBody)
        if (response.status === "error") {
            toaster.error(response.message)
            isLoadingCreating.value = false
        }
        else if (response.status === "success") {
            router.push({name: 'FlowView', params: {workflow_id: route.params.workflow_id}})
            isLoadingCreating.value = false
        }

    }

    return {
        isCreateButtonActive,
        isLoadingCreating,
        createConnection,
    }
}
